import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class SeguradoraService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getSeguradoras(ordem = null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/seguradora' + (ordem ? '/ordem/' + ordem : ''))
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getSeguradora(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/seguradora/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	criaSeguradora(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/seguradora', {
				seguradora_nome: data.seguradora_nome,
				seguradora_telefone: data.seguradora_telefone,
				seguradora_email: data.seguradora_email
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	editaSeguradora(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/seguradora/' + data.seguradora_id, {
				seguradora_nome: data.seguradora_nome,
				seguradora_telefone: data.seguradora_telefone,
				seguradora_email: data.seguradora_email
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	apagaSeguradora(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/seguradora/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getSeguradorasByUsuario(usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/seguradora/usuario/' + usuario_id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}
}
